module.exports = __webpack_public_path__ + "static/media/cheerag_shirodaria.ad2fea0c.png";